import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./index.scss";

const TestimonialCarousel = ({ images }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <div className="testimonial-carousel">
      <Slider {...settings}>
        {images &&
          images.map((value, index) => (
            <div className="testimonial-slide" key={index}>
              <div className="content">{value.feedback}</div>
              <div className="client-name">{value.clientName}</div>
            </div>
          ))}
      </Slider>
    </div>
  );
};
export default TestimonialCarousel;
